import React from "react";
import Grid from "@material-ui/core/Grid";

const CountryLabelWithFlag = ({country}) => {
  return (
    <Grid container spacing={1} alignItems={'center'}>
      <Grid item xs={'auto'} style={{display: 'inline-flex'}}>
        <svg height={14} width={18}><use href={`/static/flags.svg#flag-${country.uid.toLowerCase()}`}/></svg>
      </Grid>
      <Grid item xs>{country.text}</Grid>
    </Grid>
  )
};

export default CountryLabelWithFlag;